import { MODAL_OPEN, MODAL_CLOSE, MODAL_STATUS_CHANGE } from "../action-types/modal"

const modalStatusHandler =
    ({ modalProjectId, currentStep, modalShow }) =>
    (dispatch) => {
        dispatch(modalShowHandler(modalShow))
        dispatch(modalProjectIdHandler(modalProjectId, currentStep))
    }

const modalShowHandler = (modalShow) => {
    if (modalShow) {
        return { type: MODAL_OPEN }
    }
    return { type: MODAL_CLOSE }
}

const modalProjectIdHandler = (modalProjectId, currentStep) => {
    if (modalProjectId) return { type: MODAL_STATUS_CHANGE, payload: { modalProjectId, currentStep } }
    return { type: MODAL_STATUS_CHANGE, payload: { modalProjectId: null, currentStep } }
}

export default modalStatusHandler
